import { render } from "./monitor.vue?vue&type=template&id=0650ec5e&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=0650ec5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0650ec5e"]])

export default __exports__